import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react"; // Import PersistGate
import App from "./App";
import { store, persistor } from "./store"; // Import store and persistor
import { PostHogProvider } from "posthog-js/react";
import { HelmetProvider } from "react-helmet-async";

// Analytics should only ever describe real visitors. Development hosts and
// staff browsers were reporting into the production project — the office IP
// alone was the largest single source of events on the category pages.
//
// Non-live hosts start opted out. ?ph_optout=1 opts a browser out permanently
// and ?ph_optin=1 undoes it, so staff stay excluded no matter which network
// they are on — an IP filter silently stops working when the office IP
// changes. public/index.html honours the same switch for GA4.
const isLiveSite =
	typeof window !== "undefined" &&
	(window.location.hostname === "offcutshades.com" ||
		window.location.hostname === "www.offcutshades.com");

const options = {
	api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
	opt_out_capturing_by_default: !isLiveSite,
	loaded: (posthog) => {
		const params = new URLSearchParams(window.location.search);
		if (params.get("ph_optout") === "1") posthog.opt_out_capturing();
		if (params.get("ph_optin") === "1") posthog.opt_in_capturing();
	},
};

// Use PersistGate to wrap your App component
createRoot(document.getElementById("root")).render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<PostHogProvider
				apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
				options={options}
			>
				<HelmetProvider>
					<App />
				</HelmetProvider>
			</PostHogProvider>
		</PersistGate>
	</Provider>
);
